import { css } from "lit";
export const componentStyles = css `
:host {
  display: -ms-grid;
  display: grid;
  --newsletter-signup-background-color: var(--xdlColorXING);
  --newsletter-signup-color: var(--xdlPalettePetrol12);
  background-color: var(--newsletter-signup-background-color);
  color: var(--newsletter-signup-color);
  -webkit-font-feature-settings: 'clig' off, 'liga' off;
          font-feature-settings: 'clig' off, 'liga' off;
  font-family: var(--font-brand-sans-stack);
  padding-inline: var(--spaceXL);
  border-radius: var(--spaceXL);
}

h3 {
  font-family: var(--font-brand-bold-stack);
  -webkit-margin-before: 0;
          margin-block-start: 0;
}

:host([screen="success"]){
  -ms-grid-columns: 1fr var(--spaceL) 1fr;
  grid-template-columns: 1fr 1fr;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: var(--spaceL);
}

:host([screen="success"]) svg {
  -ms-grid-column-align: self-end;
      justify-self: self-end;
}

:host([screen="success"]) h3, :host([data-screen="success"]) p {
  text-align: left;
}

:host([screen="pending"]){
  opacity: 0.8;
}

@supports (container-type: inline-size) {
  :host {
    container-type: inline-size;
  }

  @container (min-width: 383px) {
    h3, p {
      text-align: center;
    }

    h3 {
      font-size: calc(24/16 * 1rem);
      line-height: 1.25;
    }

    form {
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
          -ms-flex-direction: row;
              flex-direction: row;
    }

    input[type="email"] {
      -webkit-box-flex: 1;
          -ms-flex-positive: 1;
              flex-grow: 1;
    }
  }

  @container (max-width: 382px) {
    h3 {
      font-size: 1rem;
      line-height: 1.875;
    }

    form {
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
          -ms-flex-direction: column;
              flex-direction: column;
    }
  }
}

@supports not (container-type: inline-size) {
  @media (min-width: 496px){
    h3, p {
      text-align: center;
    }

    h3 {
      font-size: calc(24/16 * 1rem);
      line-height: 1.25;
    }

    form {
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
          -ms-flex-direction: row;
              flex-direction: row;
    }

    input[type="email"] {
      -webkit-box-flex: 1;
          -ms-flex-positive: 1;
              flex-grow: 1;
    }
  }

  @media (max-width: 382px) {
    h3 {
      font-size: 1rem;
      line-height: 1.875;
    }

    form {
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
          -ms-flex-direction: column;
              flex-direction: column;
    }

    input[type="email"] {
      -webkit-box-flex: 1;
          -ms-flex-positive: 1;
              flex-grow: 1;
    }
  }
}

h3 {
  font-weight: 700;
}

p {
  font-size: 1rem;
  font-weight: 400;
  line-height: normal;
  max-width: 40ch;
  margin-inline: auto;
}

.error-msg {
  color: var(--xdlPaletteRed08);
  font-size: calc(12/16 * 1rem);
  -webkit-padding-start: var(--spaceL);
          padding-inline-start: var(--spaceL);
}

form {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: var(--spaceS);
}

form[data-errors="true"] {
  margin-bottom: var(--spaceL);
}

input[type="email"] {
  background-color: var(--xdlColorBackground);
  color: var(--xdlColorTextTertiary);
  border-radius: var(--spaceXL);
  padding-block: var(--spaceM);
  -webkit-padding-start: var(--spaceL);
          padding-inline-start: var(--spaceL);
  font-size: calc(14/16 * 1rem);
  line-height: 1.27;
  border: none;
  font-family: var(--font-brand-sans-stack);
}

button[type="submit"] {
  background-color: var(--xdlColorButtonStrong);
  color: var(--xdlPaletteWhite);
  border-radius: var(--spaceXL);
  padding-block: var(--spaceM);
  padding-inline: var(--spaceXL);
  font-weight: 700;
  font-size: calc(14/16 * 1rem);
  line-height: 0.94;
  border: 0;
  font-family: var(--font-brand-bold-stack);
}

button[type="submit"]:hover {
  background-color: var(--xdlPaletteGrayPlain10);
}
`;
//# sourceMappingURL=newsletter-signup.css.js.map